<template>
  <el-card>
    <div slot="header" class="clearfix">
      <el-col :lg="8">
        <el-page-header @back="back" title :content="$t('pdv-relatorio')"></el-page-header>
      </el-col>
    </div>
    <el-form :model="ruleForm" ref="ruleForm" label-position="right" label-width="120px" :inline="true">
      <el-row :gutter="5">
        <el-col :span="24">
          <el-form-item :label="$t('data')" prop="range" class="is-required">
            <el-date-picker v-model="ruleForm.range" type="date" align="right" unlink-panels clearable range-separator="à"
              format="dd/MM/yyyy" start-placeholder="Inicio" end-placeholder="Fim"></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('atendente')" prop="attendence" class="is-required">
            <el-select ref="attendence" v-model="ruleForm.attendence" filterable v-on:keyup.native.enter="enter"
              v-loading="loading" :multiple="false" placeholder="Selecione  uma opção">
              <el-option-group v-for="group in tableData" :key="group.label" :label="group.label">
                <el-option v-for="row of group.options" :key="row.id" :label="row.name" :value="row.id"></el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
          <el-button type="info" @click="fetchRecords()">Visualizar</el-button>
          <el-button @click="proof('pdf')"><i class="fa fa-file-pdf-o" aria-hidden="true"></i>&nbsp;Comprovante</el-button>
          <el-button @click="proof('csv')"><i class="fa fa-file-excel-o" aria-hidden="true"></i>&nbsp;CSV</el-button>
        </el-col>
      </el-row>
    </el-form>
    <br />
    <PdvUserTimeline ref="userTimeline" :userId="ruleForm.attendence" :startedAt="ruleForm.range"
      v-show="ruleForm.dashboard" />
  </el-card>
</template>

<script>
import { UserService } from "@/services/users/user.services";
import PdvUserTimeline from "./dashboard/PdvUserTimeline.vue";
import { PdvDashboardService } from "@/services/pdv/pdv.dashboard.services";
import moment from "moment";
import "moment/locale/pt-br";

export default {
  name: "PdvTimeline",
  components: {
    PdvUserTimeline
  },
  methods: {
    back() {
      this.$router.replace({
        name: 'pdv',
      })
    },
    proof(type = 'pdf') {
      const vm = this;
      const s = moment(vm.ruleForm.range);
      const loading = vm.$loading(vm.$options.loading);
      PdvDashboardService.proof(
        s.format("YYYY-MM-DD"),
        vm.ruleForm.attendence,
        type
      )
        .then((response) => {
          const downloadLink = document.createElement("a");
          const fileName = `caixa.${s.format("YYYY-MM-DD")}.${type}`;

          if (type === 'csv') {
            if (!response || !String(response).startsWith('data:text/csv')) {
              this.$message({ type: "error", duration: 5000, message: "Resposta invalida para exportacao CSV." });
              return;
            }
            const csvContent = decodeURIComponent(
              String(response).replace(/^data:text\/csv;charset=utf-8,?/i, '')
            );
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            downloadLink.href = URL.createObjectURL(blob);
            downloadLink.download = fileName;
          } else {
            downloadLink.href = response;
            downloadLink.download = fileName;
          }

          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
          if (type === 'csv') {
            URL.revokeObjectURL(downloadLink.href);
          }
        })
        .catch((error) => {
          this.$message({ type: "error", duration: 5000, message: error });
        })
        .finally(() => loading.close());
    },
    fetchRecords() {
      const vm = this;
      vm.ruleForm.dashboard = true;
      vm.$refs.userTimeline.fetch();
    }
  },
  data() {
    return {
      loading: false,
      ruleForm: {
        range: new Date(),
        dashboard: false,
        attendence: '',
      },
      tableData: []
    }
  },
  mounted() {
    const vm = this;
    vm.loading = true;
    UserService.me()
      .then((user) => {
        UserService.pdv()
          .then((response) => {
            const groupList = [];
            for (const data of response) {
              const groupData = groupList.find(x => x.label === data.companyname);
              if (groupData) {
                groupData.options.push(data)
              } else {
                groupList.push({
                  label: data.companyname,
                  options: [data],
                })
              }
            }
            vm.tableData = groupList;
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: error,
            });
          })
          .finally(() => vm.loading = false)
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      });

  }
};
</script>

<style>
.btn-card {
  width: 180px;
  height: 100px;
}

.icon-large {
  height: 40px;
}
</style>